export default __webpack_public_path__ + "static/media/key_features_easy_intergration.3308b37f.svg";